class MiniCartToggle extends HTMLElement {
  constructor() {
    super()

    const isCartPage = document.body.classList.contains('template-cart')

    this.window = window;
    this.cartIcon = document.getElementById('cart-icon-bubble')
    this.miniCart = document.getElementById('mini-cart')
    this.receivedElement;
    this.checkIfHovered = null
    this.checkIfTouched = null
    this.openingCart;

    if (this.miniCart.classList.contains('hovered')) {
      this.miniCart.classList.remove('hovered')
    }

    this.closeCartIcon = this.querySelector('.js-cart-close')
    this.cartIcon.addEventListener('click', (evt) => {
      evt.preventDefault()
      if (!isCartPage) {
        this.open()
        if (this.cartIcon.classList.contains('open-by-adding')) {
          this.cartIcon.classList.remove('open-by-adding')
          const isMobile = () => window.matchMedia('(max-width: 749px)').matches
          if (!isMobile()){
            this.openingCart = setTimeout(() => {
              this.addEventListenerToMouseMove()
            }, 3000);
          } else {
            this.miniCart.classList.remove('touch--active')
            this.addEventListenerToTouchMove()

            setTimeout(() => {
              if (!this.miniCart.classList.contains('touch--active')) this.close()
            }, 3000);
          }
        }
      }
    })
    this.window.addEventListener('keyup', (event) => {
      if (event.key === "Escape") {
        this.checkIfHovered = null
        this.checkIfTouched = null
        clearTimeout(this.openingCart)
        this.close()
      }
    })

    if (!isCartPage) {
      this.onBodyClick = this.handleBodyClick.bind(this)
    }

    if (this.closeCartIcon) {
      this.closeCartIcon.addEventListener('click', () => {
        this.checkIfHovered = null
        this.checkIfTouched = null
        clearTimeout(this.openingCart)
        this.close()
      })
    }
  }

  open() {
    this.miniCart.classList.add('animate', 'active')
    this.miniCart.addEventListener(
      'transitionend',
      () => {
        this.cartIcon.focus()
      },
      { once: true }
    )
    trapFocus(this.miniCart)

    document.body.addEventListener('click', this.onBodyClick)
    document.body.classList.add('overflow-hidden')
  }

  close() {
    this.miniCart.classList.remove('active')

    removeTrapFocus()
    document.body.removeEventListener('click', this.onBodyClick)
    document.body.classList.remove('overflow-hidden')
  }

  handleBodyClick(evt) {
    const target = evt.target

    if (
      target !== this.miniCart &&
      !target.closest('#cart-icon-bubble') &&
      !this.miniCart.contains(target)
    ) {
      this.checkIfHovered = null
      this.checkIfTouched = null
      clearTimeout(this.openingCart)
      this.close()
    }
  }

  addEventListenerToMouseMove(e) {
    this.checkIfHovered = (e) => {
      this.receivedElement = document.elementFromPoint(e.clientX, e.clientY);

      if (this.receivedElement?.classList.contains('mini-cart__overlay')) {
        document.removeEventListener('mousemove', this.checkIfHovered, true);
        this.checkIfHovered = null;
        this.close();
      }
    };
  
    document.addEventListener('mousemove', this.checkIfHovered, true);
  }

  addEventListenerToTouchMove(e) {
    this.checkIfTouched = (e) => {
      this.receivedElement = document.elementFromPoint(e.touches[0].clientX, e.touches[0].clientY);
      if (this.miniCart.contains(this.receivedElement)) this.miniCart.classList.add('touch--active')
      document.removeEventListener('touchstart', this.checkIfTouched, true);
    };

    document.addEventListener('touchstart', this.checkIfTouched, true);
  }
}

customElements.define('mini-cart-toggle', MiniCartToggle)
